function handleIntersection(entries) {
  entries.map((entry) => {
    if (entry.isIntersecting) {
      document
        .querySelector('.wpneo-listings')
        .classList.remove('scrolled-donor-box');
    } else {
      document
        .querySelector('.wpneo-listings')
        .classList.add('scrolled-donor-box');
    }
  });
}

export const donorScroll = () => {
  if (document.querySelector('.wpneo-listings') && window.screen.width < 600) {
    const target = document.querySelector('.mobile-donation-endpoint');
    const observer = new IntersectionObserver(handleIntersection);
    observer.observe(target);
  }
};
